import $ from 'jquery';
import 'jquery-validation';
import { forEach } from 'lodash';

$.validator.addMethod('minStrict', (value, el, param) => value > param);
$.validator.addMethod('maxStrict', (value, el, param) => value < param);
$.validator.addMethod('format', (value, el, param) => param.test(value));
$.validator.addMethod('isDTMValid', (value, el, param) => {
  if (value === 'DTM') return param[0];
  if (value === 'TakeOffGPS') return true;
  return true;
});
$.validator.addMethod('multiemails', (value, el, param) => {
  const emails = value.split(/[;,]+/); // split element by , and ;
  let valid = true;
  // eslint-disable-next-line no-return-assign
  forEach(emails, email => (valid = valid && param.test(email.trim())));
  return valid;
});

export default (form, options) => {
  return $(form).validate(options);
};
